import { DotLottie } from '@lottiefiles/dotlottie-web';

export default ($lottieplayer) => {
    if ($lottieplayer.length > 0) {
        $lottieplayer.each((index, element)=>{
            const data = $(element).data('lottieplayer');
            const canvas = $(`#${$(element).attr('id')}`)[0];

            new DotLottie({
                canvas: canvas,
                ...data
            });
        })
    }
}